/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpSocialIcons_user = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSocialIcons_user",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PinterestPinIcon_user",
      "args": null
    }
  ],
  "type": "User"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/social/__generated__/PdpSocialIcons_user.graphql.js